/* eslint-disable */

import * as companyManagementService from "../../../services/company";
import * as settings from "../../../services/settings";

import { Button, Card, Col, Form, InputNumber, Modal, Row, Spin, Typography, notification } from "antd";
import { useEffect, useState } from "react";

import { useAccessToken } from "../../../contexts/AccessTokenContext";

const { Title } = Typography;

export const ModelCreateFormula = ({
  t,
  isModalOpen,
  handleOk,
  handleCancel,
  viewFormulaDataByOne,
  fetchCompanyFormula,
  setIsModalOpen,
}) => {
  const { accessToken } = useAccessToken();
  const [formFormula] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const setFormulaData = (data) => {
    if (isModalOpen) {
      let formula = data;
      formFormula.setFieldValue("threshold_a", formula.threshold_a);
      formFormula.setFieldValue("threshold_b", formula.threshold_b);
      formFormula.setFieldValue("threshold_c", formula.threshold_c);
      formFormula.setFieldValue("threshold_d", formula.threshold_d);
      formFormula.setFieldValue("threshold_e", formula.threshold_e);

      // Check formula volume is land or sea
      if (formula.app_companyvolumeformula.length > 0) {
        const volumeFormula = formula.app_companyvolumeformula;

        const formulaVolumeLand = volumeFormula.find((item) => item.route === "land");
        const formulaVolumeSea = volumeFormula.find((item) => item.route === "sea");
        // set formula volume sea
        formFormula.setFieldValue("volume_sea_from", formulaVolumeSea.volume_from);
        formFormula.setFieldValue("volume_sea_to", formulaVolumeSea.volume_to);
        formFormula.setFieldValue("volume_sea_a", formulaVolumeSea.a);
        formFormula.setFieldValue("volume_sea_b", formulaVolumeSea.b);
        formFormula.setFieldValue("volume_sea_c", formulaVolumeSea.c);
        formFormula.setFieldValue("volume_sea_d", formulaVolumeSea.d);
        formFormula.setFieldValue("volume_sea_e", formulaVolumeSea.e);
        // set formula volume land
        formFormula.setFieldValue("volume_land_from", formulaVolumeLand.volume_from);
        formFormula.setFieldValue("volume_land_to", formulaVolumeLand.volume_to);
        formFormula.setFieldValue("volume_land_a", formulaVolumeLand.a);
        formFormula.setFieldValue("volume_land_b", formulaVolumeLand.b);
        formFormula.setFieldValue("volume_land_c", formulaVolumeLand.c);
        formFormula.setFieldValue("volume_land_d", formulaVolumeLand.d);
        formFormula.setFieldValue("volume_land_e", formulaVolumeLand.e);
      }

      if (formula.app_companyweightformula.length > 0) {
        const weightFormula = formula.app_companyweightformula;

        const formulaWeightLand = weightFormula.find((item) => item.route === "land");
        const formulaWeightSea = weightFormula.find((item) => item.route === "sea");

        // set formula volume sea
        formFormula.setFieldValue("weight_sea_form", formulaWeightSea.weight_from);
        formFormula.setFieldValue("weight_sea_to", formulaWeightSea.weight_to);
        formFormula.setFieldValue("weight_sea_a", formulaWeightSea.a);
        formFormula.setFieldValue("weight_sea_b", formulaWeightSea.b);
        formFormula.setFieldValue("weight_sea_c", formulaWeightSea.c);
        formFormula.setFieldValue("weight_sea_d", formulaWeightSea.d);
        formFormula.setFieldValue("weight_sea_e", formulaWeightSea.e);
        // set formula volume land
        formFormula.setFieldValue("weight_land_from", formulaWeightLand.weight_from);
        formFormula.setFieldValue("weight_land_to", formulaWeightLand.weight_to);
        formFormula.setFieldValue("weight_land_a", formulaWeightLand.a);
        formFormula.setFieldValue("weight_land_b", formulaWeightLand.b);
        formFormula.setFieldValue("weight_land_c", formulaWeightLand.c);
        formFormula.setFieldValue("weight_land_d", formulaWeightLand.d);
        formFormula.setFieldValue("weight_land_e", formulaWeightLand.e);
      }
    }
  };

  const onSubmitFormula = async () => {
    const values = await formFormula.getFieldsValue();

    let formulaId = viewFormulaDataByOne.id;

    const prepareDataFormula = {
      id: formulaId,
      threshold_a: Number(values.threshold_a),
      threshold_b: Number(values.threshold_b),
      threshold_c: Number(values.threshold_c),
      threshold_d: Number(values.threshold_d),
      threshold_e: Number(values.threshold_e),
      company_formula_volume: {
        sea: {
          volume_from: Number(values.volume_sea_from) || 0,
          volume_to: Number(values.volume_sea_to) || 0,
          a: Number(values.volume_sea_a) || 0,
          b: Number(values.volume_sea_b) || 0,
          c: Number(values.volume_sea_c) || 0,
          d: Number(values.volume_sea_d) || 0,
          e: Number(values.volume_sea_e) || 0,
        },
        land: {
          volume_from: Number(values.volume_land_from) || 0,
          volume_to: Number(values.volume_land_to) || 0,
          a: Number(values.volume_land_a) || 0,
          b: Number(values.volume_land_b) || 0,
          c: Number(values.volume_land_c) || 0,
          d: Number(values.volume_land_d) || 0,
          e: Number(values.volume_land_e) || 0,
        },
      },
      company_formula_weight: {
        land: {
          weight_from: Number(values.weight_land_from) || 0,
          weight_to: Number(values.weight_land_to) || 0,
          a: Number(values.weight_land_a) || 0,
          b: Number(values.weight_land_b) || 0,
          c: Number(values.weight_land_c) || 0,
          d: Number(values.weight_land_d) || 0,
          e: Number(values.weight_land_e) || 0,
        },
        sea: {
          weight_from: Number(values.weight_sea_form) || 0,
          weight_to: Number(values.weight_sea_to) || 0,
          a: Number(values.weight_sea_a) || 0,
          b: Number(values.weight_sea_b) || 0,
          c: Number(values.weight_sea_c) || 0,
          d: Number(values.weight_sea_d) || 0,
          e: Number(values.weight_sea_e) || 0,
        },
      },
    };

    if (viewFormulaDataByOne.app_companyvolumeformula.length > 0) {
      let formulaVolume = viewFormulaDataByOne.app_companyvolumeformula;
      //prepare data formula volume
      let formulaVolumeLand = formulaVolume.find((item) => item.route === "land");
      prepareDataFormula.company_formula_volume.land.id = formulaVolumeLand.id;

      let formulaVolumeSea = formulaVolume.find((item) => item.route === "sea");
      prepareDataFormula.company_formula_volume.sea.id = formulaVolumeSea.id;
    }

    if (viewFormulaDataByOne.app_companyweightformula.length > 0) {
      let formulaWeight = viewFormulaDataByOne.app_companyweightformula;
      //   //prepare data formula weight
      let formulaWeightLand = formulaWeight.find((item) => item.route === "land");
      prepareDataFormula.company_formula_weight.land.id = formulaWeightLand.id;

      let formulaWeightSea = formulaWeight.find((item) => item.route === "sea");
      prepareDataFormula.company_formula_weight.sea.id = formulaWeightSea.id;
    }

    setLoading(true);
    try {
      const response = await companyManagementService.updateCompanyFormula(accessToken, prepareDataFormula);
      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"update Success"}</>);
      setIsModalOpen(false);
      fetchCompanyFormula();
      setLoading(false);
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[ModelCreateFormula] onSubmitFormula: ", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (accessToken) {
      formFormula.setFieldValue();
      setFormulaData(viewFormulaDataByOne);
    }
  }, [accessToken, setFormulaData]);

  return (
    <>
      {contextHolder}
      <Modal
        title={t("Company_Create.Create_Formula.Text_Edit_Formula")}
        open={isModalOpen}
        className="rounded-lg border-2"
        closable={false}
        centered={true}
        forceRender={true}
        width={1280}
        footer={() => (
          <>
            <Button type="primary" onClick={onSubmitFormula}>
              {t("BTN_Save", { ns: "buttons" })}
            </Button>
            <Button onClick={handleCancel}>{t("BTN_Cancel", { ns: "buttons" })}</Button>
          </>
        )}
      >
        <Spin spinning={loading}>
          <Col span={24}>
            <Form form={formFormula} labelAlign="left" labelCol={{ flex: "140px" }}>
              <Form.Item
                label={t("Company_Create.Create_Routes.Title_Routes") + ":"}
                name="origin"
                key="origin"
                style={{ marginBottom: "1rem" }}
              >
                <Title level={5}>
                  {isModalOpen
                    ? `${viewFormulaDataByOne.app_warehouse_app_companyformula_origin_idToapp_warehouse.warehouse_code}
                    -
                    ${viewFormulaDataByOne.app_warehouse_app_companyformula_destination_idToapp_warehouse.warehouse_code}`
                    : ""}
                </Title>
              </Form.Item>
              <Form.Item
                label={`${t("Company_Create.Create_Formula.Threshold")} A :`}
                name="threshold_a"
                key="threshold_a"
                style={{ marginBottom: "1rem" }}
              >
                <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
              </Form.Item>
              <Form.Item
                label={`${t("Company_Create.Create_Formula.Threshold")} B :`}
                name="threshold_b"
                key="threshold_b"
                style={{ marginBottom: "1rem" }}
              >
                <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
              </Form.Item>
              <Form.Item
                label={`${t("Company_Create.Create_Formula.Threshold")} C :`}
                name="threshold_c"
                key="threshold_c"
                style={{ marginBottom: "1rem" }}
              >
                <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
              </Form.Item>
              <Form.Item
                label={`${t("Company_Create.Create_Formula.Threshold")} D :`}
                name="threshold_d"
                key="threshold_d"
                style={{ marginBottom: "1rem" }}
              >
                <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
              </Form.Item>
              <Form.Item
                label={`${t("Company_Create.Create_Formula.Threshold")} E :`}
                name="threshold_e"
                key="threshold_e"
                style={{ marginBottom: "1rem" }}
              >
                <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
              </Form.Item>
              <Card
                style={{
                  marginTop: 16,
                }}
                type="inner"
                title={t("Company_Create.Create_Formula.Formula_Volume.Title_Formula_Volume")}
              >
                <Row gutter={24}>
                  <Col className="gutter-row" span={3}>
                    <div>{t("Company_Create.Create_Routes.Title_Routes")}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{t("Company_Create.Create_Formula.Formula_Volume.Title_Formula_Volume_From")}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{t("Company_Create.Create_Formula.Formula_Volume.Title_Formula_Volume_To")}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{"A"}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{"B"}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{"C"}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{"D"}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{"E"}</div>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col className="gutter-row" span={3}>
                    <div>{t("Company_Create.Create_Formula.Formula_LAND")}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_land_from" key="volume_land_from" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.000000" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_land_to" key="volume_land_to" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.000000" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_land_a" key="volume_land_a" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_land_b" key="volume_land_b" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_land_c" key="volume_land_c" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_land_d" key="volume_land_d" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_land_e" key="volume_land_e" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col className="gutter-row" span={3}>
                    <div>{t("Company_Create.Create_Formula.Formula_SEA")}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_sea_from" key="volume_sea_from" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.000000" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_sea_to" key="volume_sea_to" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.000000" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_sea_a" key="volume_sea_a" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_sea_b" key="volume_sea_b" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_sea_c" key="volume_sea_c" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_sea_d" key="volume_sea_d" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="volume_sea_e" key="volume_sea_e" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              </Card>
              <Card
                style={{
                  marginTop: 16,
                }}
                type="inner"
                title={t("Company_Create.Create_Formula.Formula_Weight.Title_Formula_Weight")}
              >
                <Row gutter={24}>
                  <Col className="gutter-row" span={3}>
                    <div>{t("Company_Create.Create_Routes.Title_Routes")}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{t("Company_Create.Create_Formula.Formula_Weight.Title_Formula_Weight_From")}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{t("Company_Create.Create_Formula.Formula_Weight.Title_Formula_Weight_To")}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{"A"}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{"B"}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{"C"}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{"D"}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>{"E"}</div>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col className="gutter-row" span={3}>
                    <div>{t("Company_Create.Create_Formula.Formula_LAND")}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_land_from" key="weight_land_from" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_land_to" key="weight_land_to" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_land_a" key="weight_land_a" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_land_b" key="weight_land_b" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_land_c" key="weight_land_c" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_land_d" key="weight_land_d" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_land_e" key="weight_land_e" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col className="gutter-row" span={3}>
                    <div>{t("Company_Create.Create_Formula.Formula_SEA")}</div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_sea_form" key="weight_sea_form" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_sea_to" key="weight_sea_to" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_sea_a" key="weight_sea_a" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_sea_b" key="weight_sea_b" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_sea_c" key="weight_sea_c" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_sea_d" key="weight_sea_d" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="gutter-row" span={3}>
                    <div>
                      <Form.Item name="weight_sea_e" key="weight_sea_e" style={{ marginBottom: "1rem" }}>
                        <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Form>
          </Col>
        </Spin>
      </Modal>
    </>
  );
};
